import { LabelMedium, ParagraphMedium, ParagraphSmall } from 'baseui/typography';
import { getAddress, hasAddress } from '../../../Spaces/Address/utils';
import LocationView from './LocationView';
import { BuildingType, TP_Building } from './types';
import { FormattedMessage } from 'react-intl';
import { Block } from 'baseui/block';
import InsightsPanel from './InsightsPanel';

const SideviewPanel = (props: TP_Building) => {

    const name = hasAddress(props.address) ? getAddress(props.address) : '';

    return (
        <>

            <LabelMedium ><FormattedMessage id={`BuildingType.${BuildingType[props.buildingType]}`} defaultMessage={BuildingType[props.buildingType]}></FormattedMessage></LabelMedium>

            {props.showLocation && <LocationView {...props} />}
            <ParagraphMedium>{name}</ParagraphMedium>
            <InsightsPanel {...props} flexGridColumnCount={[1,1,1,1]} small></InsightsPanel> 
        </>
    );
};

export default SideviewPanel;